import React, { useState } from 'react';
import { Card, Col, Row, Badge } from 'react-bootstrap';
import { FaFileExport, FaCalculator, FaFileInvoiceDollar, FaClipboardCheck } from 'react-icons/fa';
import NetBrutCalculator from './outilsComptabilite/NetBrutCalculator';
import FichePaieChantier from './outilsComptabilite/FichePaieChantier';
import ControleJournalPaie from './outilsComptabilite/ControleJournalPaie';

const TOOLS = [
  {
    id: 'net-brut',
    title: 'Calcul Net cible → Brut',
    icon: <FaCalculator size={26} />,
    description: 'Calcule instantanément le salaire brut nécessaire pour atteindre un net cible (mensuel ou horaire), avec import/export Excel.',
    available: true,
  },
  {
    id: 'fiche-paie-chantier',
    title: 'Fiches de paie par chantier',
    icon: <FaFileInvoiceDollar size={26} />,
    description: "Importe un fichier Excel de paie et génère les fiches de paie imprimables, regroupées par chantier.",
    available: true,
  },
  {
    id: 'controle',
    title: 'Contrôle',
    icon: <FaClipboardCheck size={26} />,
    description: 'Importe le Journal de Paie Cegid (PDF), recalcule chaque bulletin (cotisations, net imposable, IR, net), rapproche les totaux et compare au mois précédent.',
    available: true,
    adminOnly: true,
  },
  {
    id: 'export-documents',
    title: 'Export & génération de documents',
    icon: <FaFileExport size={26} />,
    description: 'Export Excel/PDF des données comptables, génération de documents.',
    available: false,
  },
];

const OutilsComptabilitePage = ({ user }) => {
  const [selectedTool, setSelectedTool] = useState(null);
  const isAdmin = user?.role === 'admin';
  const tools = TOOLS.filter((t) => !t.adminOnly || isAdmin);

  if (selectedTool === 'net-brut') {
    return (
      <div className="container mt-4">
        <NetBrutCalculator onBack={() => setSelectedTool(null)} />
      </div>
    );
  }

  if (selectedTool === 'fiche-paie-chantier') {
    return (
      <div className="container mt-4">
        <FichePaieChantier onBack={() => setSelectedTool(null)} />
      </div>
    );
  }

  if (selectedTool === 'controle' && isAdmin) {
    return (
      <div className="container-fluid mt-4 px-lg-4">
        <ControleJournalPaie onBack={() => setSelectedTool(null)} />
      </div>
    );
  }

  return (
    <div className="container mt-4">
      <h3 className="mb-1">🧮 Outils Comptabilité</h3>
      <p className="text-muted mb-4">Espace dédié aux différents traitements et utilitaires comptables.</p>

      <Row className="g-3">
        {tools.map((tool) => (
          <Col key={tool.id} md={6} lg={4}>
            <Card
              className="h-100 shadow-sm"
              style={{ opacity: tool.available ? 1 : 0.7, cursor: tool.available ? 'pointer' : 'default' }}
              onClick={() => tool.available && setSelectedTool(tool.id)}
            >
              <Card.Body className="d-flex flex-column">
                <div className="d-flex align-items-center gap-2 mb-2">
                  {tool.icon}
                  <Card.Title className="mb-0">{tool.title}</Card.Title>
                  {tool.adminOnly && <Badge bg="danger" className="ms-auto">Admin</Badge>}
                </div>
                <Card.Text className="text-muted flex-grow-1">{tool.description}</Card.Text>
                <Badge bg={tool.available ? 'success' : 'secondary'} className="align-self-start">
                  {tool.available ? 'Ouvrir' : 'Bientôt disponible'}
                </Badge>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
};

export default OutilsComptabilitePage;
